import {
  DollarOutlined,
  FilePdfOutlined,
  HomeOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu, MenuProps } from "antd";
import { memo } from "react";
import type { NavigateFunction } from "react-router-dom";
import { authController } from "../../../AppController";

const getLeftMenuData = (role: string, navigate: NavigateFunction) => {
  const ATMenu: MenuProps["items"] = [
    {
      label: "Consent",
      key: "consent",
      icon: <UserOutlined />,
      onClick: () => navigate("/consent"),
    },
  ];

  const billingPractionerMenu: MenuProps["items"] = [
    {
      label: "Residents",
      key: "residents",
      icon: <UserOutlined />,
      onClick: () => navigate("/residents"),
    },
    {
      label: "Billing",
      key: "billing",
      icon: <DollarOutlined />,
      onClick: () => navigate("/billing"),
    },
  ];

  const billingAdministratorMenu: MenuProps["items"] = [
    {
      label: "Billing",
      key: "billing",
      icon: <DollarOutlined />,
      onClick: () => navigate("/billing"),
    },
  ];

  const accountManagerMenu: MenuProps["items"] = [
    {
      label: "Dashboard",
      key: "dashboard",
      icon: <HomeOutlined />,
      onClick: () => navigate("/dashboard"),
    },
    {
      label: "Residents",
      key: "residents",
      icon: <UserOutlined />,
      onClick: () => navigate("/residents"),
    },
    {
      label: "Care Coordination",
      key: "care-coordination",
      icon: <SolutionOutlined />,
      onClick: () => navigate("/care-coordination"),
    },
    {
      label: "Rooms",
      key: "rooms",
      icon: (
        <svg
          viewBox="0 0 512 512"
          focusable="false"
          width="1em"
          height="1em"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M480,226.15V80a48,48,0,0,0-48-48H80A48,48,0,0,0,32,80V226.15C13.74,231,0,246.89,0,266.67V472a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V416H480v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V266.67C512,246.89,498.26,231,480,226.15ZM64,192a32,32,0,0,1,32-32H208a32,32,0,0,1,32,32v32H64Zm384,32H272V192a32,32,0,0,1,32-32H416a32,32,0,0,1,32,32ZM80,64H432a16,16,0,0,1,16,16v56.9a63.27,63.27,0,0,0-32-8.9H304a63.9,63.9,0,0,0-48,21.71A63.9,63.9,0,0,0,208,128H96a63.27,63.27,0,0,0-32,8.9V80A16,16,0,0,1,80,64ZM32,384V266.67A10.69,10.69,0,0,1,42.67,256H469.33A10.69,10.69,0,0,1,480,266.67V384Z"
          />
        </svg>
      ),
      onClick: () => navigate("/rooms"),
    },
    {
      label: "Reports",
      key: "reports",
      icon: <FilePdfOutlined />,
      onClick: () => navigate("/reports"),
    },
    {
      label: "Billing",
      key: "billing",
      icon: <DollarOutlined />,
      onClick: () => navigate("/billing"),
    },
    {
      label: "Consent",
      key: "consent",
      icon: <UserOutlined />,
      onClick: () => navigate("/consent"),
    },
  ];

  const clinicMenu: MenuProps["items"] = [
    {
      label: "Dashboard",
      key: "dashboard",
      icon: <HomeOutlined />,
      onClick: () => navigate("/dashboard"),
    },
    {
      label: "Residents",
      key: "residents",
      icon: <UserOutlined />,
      onClick: () => navigate("/residents"),
    },
    {
      label: "Care Coordination",
      key: "care-coordination",
      icon: <SolutionOutlined />,
      onClick: () => navigate("/care-coordination"),
    },
    {
      label: "Rooms",
      key: "rooms",
      icon: (
        <svg
          viewBox="0 0 512 512"
          focusable="false"
          width="1em"
          height="1em"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M480,226.15V80a48,48,0,0,0-48-48H80A48,48,0,0,0,32,80V226.15C13.74,231,0,246.89,0,266.67V472a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V416H480v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V266.67C512,246.89,498.26,231,480,226.15ZM64,192a32,32,0,0,1,32-32H208a32,32,0,0,1,32,32v32H64Zm384,32H272V192a32,32,0,0,1,32-32H416a32,32,0,0,1,32,32ZM80,64H432a16,16,0,0,1,16,16v56.9a63.27,63.27,0,0,0-32-8.9H304a63.9,63.9,0,0,0-48,21.71A63.9,63.9,0,0,0,208,128H96a63.27,63.27,0,0,0-32,8.9V80A16,16,0,0,1,80,64ZM32,384V266.67A10.69,10.69,0,0,1,42.67,256H469.33A10.69,10.69,0,0,1,480,266.67V384Z"
          />
        </svg>
      ),
      onClick: () => navigate("/rooms"),
    },
    {
      label: "Reports",
      key: "reports",
      icon: <FilePdfOutlined />,
      onClick: () => navigate("/reports"),
    },
    {
      label: "Consent",
      key: "consent",
      icon: <UserOutlined />,
      onClick: () => navigate("/consent"),
    },
  ];

  if (authController.isAT(role)) {
    return ATMenu;
  }
  if (authController.isBP(role)) {
    return billingPractionerMenu;
  }
  if (authController.isBA(role)) {
    return billingAdministratorMenu;
  }
  if (authController.isVRN(role)) {
    return clinicMenu;
  }
  if (authController.isAM(role)) {
    return accountManagerMenu;
  }
  return [];
};

interface IProps {
  role: string;
  navigate: NavigateFunction;
}

export const LeftMenu: FC<IProps> = memo((props) => {
  const { role, navigate } = props;

  return (
    <Menu
      data-test-id="menu"
      mode="inline"
      items={getLeftMenuData(role, navigate)}
    />
  );
});

export const analyticsEventSettingsPaths: Record<string, string> = {
  "/change-facility": "Click on change facility button",
  "/change-password": "Tap on change password",
  "/change-pin": "Tap on change PIN ",
  "/floor-settings": "Tap on floor selection",
  "/notification-settings": "Tap on notification settings",
  "/vital-sync": "Tap on Vitals AI",
  "/contact-support": "Tap on contact support",
  "/feedback": "Tap on Feedback",
  "/reportAProblem": "Tap on report a problem",
  "/privacyPolicy": "Tap on Privacy Policy tab",
  "/bedexit-alers": "Tap on Bed Exit Alerts",
  "/intended-use": "Tap on intended use",
  "/faq": "Tap on FAQ",
};
